module.exports = __webpack_public_path__ + "static/media/Photo9.5bb00563.jpg";